export default __webpack_public_path__ + "static/media/Home Textiles.b9c52d73.jpg";